(function () {
  document.querySelectorAll('[data-filter-for]').forEach(function (trifilter) {
    const tableId = trifilter.dataset.filterFor;
    const targetList = document.getElementById(tableId);

    if (!targetList) return;

    const noResultMsg = targetList.querySelector(`[data-no-result-message]`);
    const theList = targetList.querySelector(`[data-the-list]`);
    const displayedCounter = targetList.querySelector('[data-list-displayed]');
    const totalCounter = targetList.querySelector('[data-list-total]');
    const moreButton = targetList.querySelector('[data-list-show-more-btn]');
    const pageSize = parseInt(targetList.dataset.pageSize) || 10;
    const alwaysShowVw = 1024;
    let displayedCount;
    let matchCount;

    function applyFilter() {
      let selectedDimension = []; // array of guids
      let isOdd = true; // flip flop tracking the class to apply
      matchCount = 0;

      trifilter.querySelectorAll('select').forEach(function (select) {
        // placeholder option (e.g. All Categories) has an empty value
        if (select.value) selectedDimension.push(select.value);
      });

      theList.querySelectorAll('[data-dimensions]').forEach(function (row) {
        let isMatch = selectedDimension.every((dimension) =>
          row.dataset.dimensions.indexOf(dimension) !== -1);

        row.classList.remove('odd');
        row.classList.remove('even');
        row.classList.remove('match');
        row.classList.remove('mismatch');

        if (isMatch) {
          row.classList.add('match');
          row.classList.add(isOdd ? 'odd' : 'even');
          isOdd = !isOdd;
          matchCount++;
        } else {
          row.classList.add('mismatch');
        }
      });

      if (matchCount > 0) {
        theList.style.display = '';
        if (noResultMsg) {
          noResultMsg.style.display = 'none';
        }
      } else {
        theList.style.display = 'none';
        if (noResultMsg) {
          noResultMsg.style.display = '';
        }
      }

      let params = Qs.parse(location.hash.substring(1));
      if (selectedDimension.length == 0) {
        delete params[`filter-${tableId}`];
      } else {
        params[`filter-${tableId}`] = selectedDimension.join(',');
      }
      history.replaceState(null, null, '#' + Qs.stringify(params));

      displayedCount = pageSize;
      applyPagination();
    }

    function applyPagination() {
      if (window.innerWidth >= alwaysShowVw) {
        // desktop: always show all
        moreButton.style.display = 'none';
        theList.style.maxHeight = theList.querySelector('.match') ?
          theList.querySelector('.match').clientHeight * pageSize + 'px' :
          '';
        theList.style.overflow = 'auto';

        theList.querySelectorAll('.match').forEach(function (item, i) {
          item.style.display = ''; // undo display: none from mobile
        });

      } else {
        // mobile: click to show more
        displayedCounter.innerHTML = displayedCount;
        totalCounter.innerHTML = matchCount;

        moreButton.style.display = (displayedCount < matchCount) ? '' : 'none';
        theList.style.maxHeight = '';
        theList.style.overflow = '';

        theList.querySelectorAll('.match').forEach(function (item, i) {
          item.style.display = (i < displayedCount) ? '' : 'none';
        });
      }
    }

    // load filter params
    const paramsOnLoad = Qs.parse(location.hash.substring(1));
    if (paramsOnLoad[`filter-${tableId}`]) {
      const preappliedDimensions = paramsOnLoad[`filter-${tableId}`].split(',');

      preappliedDimensions.forEach((dimension) => {
        const option = trifilter.querySelector(`option[value="${dimension}"]`);
        if (option) option.selected = true;
      });
    }

    // apply default processing
    applyFilter();
    applyPagination();

    // event handlers
    trifilter.querySelectorAll('select').forEach(function (select) {
      select.addEventListener('change', applyFilter);
    });

    moreButton.addEventListener('click', function () {
      displayedCount += pageSize;
      applyPagination();
    });

    window.addEventListener('resize', applyPagination);

  });

})();